import { Box, Grid, MenuItem, Stack, Typography } from "@mui/material";
import { memo, useContext } from "react";
import { useLocation } from "react-router-dom";
import CustomCheckBox from "../../../components/checkbox";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";

// import MultipleSelectChip from "../../../components/multiSelect";

const routerList = [0, 1, 2, 3];
const COST_TYPE = [
  {
    value: "One Of Cost",
    type: "oneOfCost",
  },
  {
    value: "Monthly",
    type: "monthly",
  },
];

const Routers = () => {
  const location = useLocation();
  const { routerValue, setRouterValue } = useContext(AppContext);
  const isDetailPage = location.pathname === "/prospect-details";

  const handleRouterValueChange = (e) => {
    const newValue = e.target.value;
    setRouterValue((prev) => ({
      ...prev,
      price:
        routerValue.costType === "oneOfCost" ? newValue * 20 : newValue * 1.5,
      value: newValue,
    }));
  };

  const handleEditRouterCharges = (e) => {
    const newValue = parseFloat(e.target.value);

    const forOneOfCost =
      routerValue.costType === "oneOfCost" &&
      newValue > routerValue.value * 100;

    const forMonthly =
      routerValue.costType === "monthly" &&
      newValue > routerValue.value * 10000;

    if (newValue < 0 || forOneOfCost || forMonthly) {
      return;
    }

    setRouterValue((prev) => ({
      ...prev,
      price: newValue,
    }));
  };

  const handleRouterCostTypeChange = (e) => {
    const newValue = e.target.value;
    setRouterValue((prev) => ({
      ...prev,
      costType: newValue,
      value: 0,
      price: 0,
    }));
  };

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        No. of Routers
      </Typography>

      <Stack mt={2} mb={1} direction={"row"} gap={1} alignItems={"flex-end"}>
        <CustomCheckBox
          isChecked={routerValue.isUpgrade}
          handleChecked={() => {
            if (!isDetailPage) {
              setRouterValue((pre) => ({ ...pre, isUpgrade: !pre.isUpgrade }));
            }
          }}
        />
        <Label
          title={"Upgrade"}
          htmlFor={"upgrade"}
          style={{ mb: 0, lineHeight: "normal" }}
        />
      </Stack>

      <Grid container spacing={2}>
        {/* <Grid item xs={12} sm={6} md={3}>
          <Label title={"Select Line"} />
          <MultipleSelectChip />
        </Grid> */}
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Cost Type"} />
          <CustomDropDown
            variant={"filled"}
            value={routerValue.costType}
            onChange={handleRouterCostTypeChange}
            readonly={isDetailPage}
          >
            {COST_TYPE.map((val, ind) => (
              <MenuItem key={ind} value={val.type}>
                {val.value}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"No. of Routers"} />
          <CustomDropDown
            variant={"filled"}
            value={routerValue.value}
            onChange={handleRouterValueChange}
            readonly={isDetailPage}
          >
            {routerList.map((val, ind) => (
              <MenuItem key={ind} value={val}>
                {val}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>
        {routerValue.value > 0 && (
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Total Cost"} htmlFor={"router-charges"} />
            <TextInput
              id={"router-charges"}
              variant={"filled"}
              required
              type={"number"}
              value={routerValue.price}
              onChange={handleEditRouterCharges}
              readonly={isDetailPage}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default memo(Routers);
